/**
 * @generated SignedSource<<c73534e3791deaccb0457fcff8341b2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationPushAppy_widgetIntegrationPushAppy$data = {
  readonly id: string;
  readonly leaderboard: ReadonlyArray<{
    readonly goal: number | null;
    readonly id: string;
    readonly progress: number | null;
    readonly title: string | null;
    readonly total: number | null;
  } | null>;
  readonly overviewSize: WidgetOverviewSize;
  readonly title: string;
  readonly " $fragmentType": "WidgetIntegrationPushAppy_widgetIntegrationPushAppy";
};
export type WidgetIntegrationPushAppy_widgetIntegrationPushAppy$key = {
  readonly " $data"?: WidgetIntegrationPushAppy_widgetIntegrationPushAppy$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationPushAppy_widgetIntegrationPushAppy">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationPushAppy_widgetIntegrationPushAppy",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetIntegrationPushAppyLeaderboardItem",
      "kind": "LinkedField",
      "name": "leaderboard",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "goal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "progress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIntegrationPushAppy",
  "abstractKey": null
};
})();

(node as any).hash = "842c0c56704bbf434fcc2116e13c7e7a";

export default node;
